var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInventory = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#292D32",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M3.17 7.44 12 12.55l8.77-5.08M12 21.61v-9.07"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#292D32",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M9.93 2.48 4.59 5.45a4.72 4.72 0 0 0-2.2 3.73v5.65a4.72 4.72 0 0 0 2.2 3.73l5.34 2.97a4.8 4.8 0 0 0 4.15 0l5.34-2.97a4.72 4.72 0 0 0 2.2-3.73V9.18a4.72 4.72 0 0 0-2.2-3.73l-5.34-2.97a4.72 4.72 0 0 0-4.15 0"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#292D32",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M17 13.24V9.58L7.51 4.1"
})));
export { SvgInventory as ReactComponent };
export default __webpack_public_path__ + "56b20fdc5db4c72b28f6ed6c1506fcb2.svg";